/* eslint-disable consistent-return */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Link } from 'react-router-dom';
import { MenuListItem } from '@pearsontechnology/aero-components';
import AccountSummary from '../../Grid/AccountSummary';
import { INSTRUCTOR_UNSCORED, INSTRUCTOR_SCORED } from '../../scoreReason';

const StyledLink = styled(Link)`
  text-decoration: none;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
`;

const StudentGrade = styled.div`
  margin-left: auto;
  margin-right: 40px;
  ${(props) =>
    props.active &&
    `
    margin-right: 18px;
  `};
`;

const StyledMenuListItem = styled(MenuListItem)`
justify-content: space-between;
`;

function StudentSummary({ list, activeStudent, active, constantRoute, maxScore, attemptId }) {
  const studentClicked = activeStudent.id;
  const state = activeStudent.state;
  const activeStudentIndex = list.map((x) => x.id).indexOf(studentClicked);
  const grade = list[activeStudentIndex].grades[0];
  const studentGrades = () => {
    if (state === INSTRUCTOR_SCORED) {
      return `${grade.score}/${maxScore}`;
    } else if (attemptId && state === INSTRUCTOR_UNSCORED) {
      return 'Grade';
    }

    return `\u2014/${maxScore}`;
  };

  return (
    <StyledLink to={`${constantRoute}/${studentClicked}`}>
      <StyledMenuListItem selected={active}>
        <AccountSummary account={activeStudent} />
        <StudentGrade active={active}>{studentGrades()}</StudentGrade>
      </StyledMenuListItem>
    </StyledLink>
  );
}

StudentSummary.propTypes = {
  activeStudent: PropTypes.object,
  active: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
  constantRoute: PropTypes.string,
  list: PropTypes.array,
  maxScore: PropTypes.number,
  attemptId: PropTypes.string,
};

export default StudentSummary;
